













import Vue from 'vue'
import Component from 'vue-class-component'

/*
{
  emojiHeading: '👩🏾🤝👩🏼',
  title: 'Peer-to-Peer Network',
  description: `
    <b>In Practice</b>: Uses technologies like IPFS, Dat and Hashgraph.
    <br><br>
    <b>In Principle</b>: A peer-to-peer network distributes the weight of resource needs to many users.
    <br><br>
    <b>Call to Action</b>: Learn more about peer-to-peer technologies like IPFS, Dat and Hashgraph.
  `
},
*/

@Component({
  components: {}
})
class DigitalCurrency13DigitalCurrencyFeatureList extends Vue {
  list: any[] = [{
    emojiHeading: '🤑',
    title: 'Universal Basic Income',
    description: `
      <b>In Practice</b>: Everyone receives a daily payment.
      <br><br>
      <b>In Principle</b>: We are all creative and our money allows us to access resources to express our creativity in today's money-based society.
      <br><br>
      <b>Call to Action</b>: Dream big, dream small. Afford to live through it all.
    `
  }, {
    emojiHeading: '❤️ + 💻',
    title: 'Open Source',
    description: `
      <b>In Practice</b>: Anyone can fork the code base and start their own currency.
      <br><br>
      <b>In Principle</b>: You can easily get started to make your own currency if our current one doesn't meet your needs.
      <br><br>
      <b>Call to Action</b>: Modify the code to your heart's content.
    `
  }, /* {
    emojiHeading: '👩🏾🤝👩🏼',
    title: 'Peer-to-Peer Network',
    description: `
      <b>In Practice</b>: Uses technologies like IPFS, Dat and Hashgraph.
      <br><br>
      <b>In Principle</b>: A peer-to-peer network distributes the weight of resource needs to many users.
      <br><br>
      <b>Call to Action</b>: Learn more about peer-to-peer technologies like IPFS, Dat and Hashgraph.
    `
  }, */ {
    emojiHeading: '🌎 + 🎭',
    title: 'Global Anonymous Support',
    description: `
      <b>In Practice</b>: Anyone can have an account.
      <br><br>
      <b>In Principle</b>: We are all citizens of a global ecosystem. No email or government issued ID ever required.
      <br><br>
      <b>Call to Action</b>: Know that you belong to a global ecosystem. Live today in a future without borders.
    `
  }]
}

export default DigitalCurrency13DigitalCurrencyFeatureList
